import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-10 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = {
  class: "tab-content",
  id: "myTabContent3"
}
const _hoisted_4 = {
  class: "tab-pane fade show active",
  id: "preview3-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "preview3-tab",
  tabindex: "0"
}
const _hoisted_5 = {
  class: "ratings",
  dir: "ltr"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("h4", { class: "fs-18 mb-4" }, "Setting and Getting Values", -1)),
      _cache[2] || (_cache[2] = _createElementVNode("ul", {
        class: "nav nav-tabs mb-4",
        id: "myTab3",
        role: "tablist"
      }, [
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link active",
            id: "preview3-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#preview3-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "preview3-tab-pane",
            "aria-selected": "true"
          }, " Preview ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link",
            id: "code3-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#code3-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "code3-tab-pane",
            "aria-selected": "false"
          }, " Code ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (heart, index) => {
              return _createElementVNode("span", {
                key: index,
                class: "rating ms-2",
                onClick: ($event: any) => (_ctx.setRating(index + 1))
              }, [
                _createElementVNode("i", {
                  class: _normalizeClass(index + 1 <= _ctx.rating ? 'ri-heart-fill' : 'ri-heart-line')
                }, null, 2)
              ], 8, _hoisted_6)
            }), 64))
          ]),
          _createElementVNode("p", _hoisted_7, "Selected Rating: " + _toDisplayString(_ctx.rating), 1)
        ]),
        _cache[0] || (_cache[0] = _createElementVNode("div", {
          class: "tab-pane fade",
          id: "code3-tab-pane",
          role: "tabpanel",
          "aria-labelledby": "code3-tab",
          tabindex: "0"
        }, [
          _createElementVNode("button", {
            class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
            "data-clipboard-target": "#basicAlertsCode3"
          }, " Copy "),
          _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
            _createTextVNode(""),
            _createElementVNode("code", {
              class: "language-markup",
              id: "basicAlertsCode3"
            }, "\n<!-- Rating Component for setting and getting values -->\n<div class=\"ratings\" dir=\"ltr\">\n  <span\n    v-for=\"(heart, index) in 5\"\n    :key=\"index\"\n    class=\"rating ms-2\"\n    @click=\"setRating(index + 1)\"\n  >\n    <i :class=\"index + 1 <= rating ? 'ri-heart-fill' : 'ri-heart-line'\"></i>\n  </span>\n</div>\n"),
            _createTextVNode("\n")
          ])
        ], -1))
      ])
    ])
  ]))
}